/**
 * About Page
 */

import React from 'react';
import { usePortal } from '../context/PortalContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
  const { branding, portal } = usePortal();
  const aboutContent = portal?.landingPage?.about ||
    `${branding.businessName} is committed to providing excellent products and services to our customers.`;
  const aboutImage = portal?.landingPage?.aboutImage;
  // Array of { name, logo } — brands this business stocks/sources from, shown as a simple logo
  // strip rather than a dedicated nav page (see the plan this was built from).
  const suppliers = portal?.landingPage?.suppliers || [];

  return (
    <>
      <Header />

      <main style={{ marginTop: '80px', minHeight: '80vh' }}>
        <section className="section">
          <div className="container">
            <div className="masthead">
              <span className="eyebrow">Our story</span>
              <h1>About Us</h1>
            </div>

            <div style={styles.content}>
              {aboutImage && <img src={aboutImage} alt={branding.businessName} style={styles.image} />}
              <p style={styles.text}>{aboutContent}</p>
            </div>

            {suppliers.length > 0 && (
              <div style={styles.suppliers}>
                <p style={styles.suppliersLabel}>Suppliers we work with</p>
                <div style={styles.supplierLogos}>
                  {suppliers.map((s) => (
                    <img key={s.name} src={s.logo} alt={s.name} title={s.name} style={styles.supplierLogo} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

const styles = {
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: '500px',
    borderRadius: '12px',
    marginBottom: '30px',
  },
  text: {
    fontSize: '1.2rem',
    lineHeight: '1.8',
    color: '#555',
  },
  suppliers: {
    marginTop: '60px',
    textAlign: 'center',
  },
  suppliersLabel: {
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: '#999',
    marginBottom: '20px',
  },
  supplierLogos: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '40px',
  },
  supplierLogo: {
    height: '40px',
    objectFit: 'contain',
    filter: 'grayscale(1)',
    opacity: 0.7,
  },
};

export default AboutPage;
